export const GET_COMPANIES = 'companies/GET_COMPANIES'
export const START_LOADING_COMPANIES = 'companies/START_LOADING_COMPANIES'
export const STOP_LOADING_COMPANIES = 'companies/STOP_LOADING_COMPANIES'
